import styled, { css } from 'styled-components';

import { COLORS as PANDA_COLORS } from '@treelab/panda';
import { COLORS } from './color';

const SIZE = {
  TABLET_PORTRAIT: '600px',
  TABLET_LANDSCAPE: '900px',
  DESKTOP: '1200px',
  DESKTOP_LARGE: '1800px',
};

export const Device = {
  tabletPortrait: `(min-width: ${SIZE.TABLET_PORTRAIT})`,
  tabletLandscape: `(min-width: ${SIZE.TABLET_LANDSCAPE})`,
  desktop: `(min-width: ${SIZE.DESKTOP})`,
  desktopLarge: `(min-width: ${SIZE.DESKTOP_LARGE})`,
};

export const AllSidesMixin = css`
  bottom: 0;
  left: 0;
  position: absolute;
  top: 0;
  right: 0;
`;

export const FillSpaceMixin = css`
  height: 100%;
  width: 100%;
`;

export const MaskMixin = css`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
`;

export const FlexCenterMixin = css`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const FlexAlignCenterMixin = css`
  align-items: center;
  display: flex;
`;

export const SpaceBelowMixin = css`
  margin-bottom: 15px;
`;

export const SpaceRight10Mixin = css`
  margin-right: 10px;
`;

export const SpaceLeft5Mixin = css`
  margin-left: 5px;
`;

export const ModalContainerMixin = css`
  background-color: ${COLORS.white};
  border-radius: 8px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.07), 0px 8px 28px rgba(0, 0, 0, 0.09);
  overflow: hidden;
`;

/** Text */
export const TextEllipsisMixin = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextSharedMixin = css<{ isSmall?: boolean }>`
  color: ${COLORS.grayText};
  font-size: ${(props) => (props.isSmall ? '14px' : '16px')};
`;

/** Components */
export const Wrapper = styled.div<{ backgroundColor?: string }>`
  background-color: ${(props) => props.backgroundColor};
  min-height: 100%;
  min-width: 960px;
  display: none;
  flex: 1 1 auto;

  @media ${Device.tabletLandscape} {
    display: flex;
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
`;

export const Content = styled.div`
  display: flex;
  margin: 50px 130px 50px 50px;
  flex: 1 1 auto;
`;

/** Made this one because i was in a rush and not sure what Content1 effects */
export const Content2 = styled.div`
  display: flex;
  margin: 50px auto;
  flex: 1 1 auto;
  padding: 0 80px;
`;

export const ListButtonMixin = css`
  align-items: center;
  border-radius: 4px;
  display: flex;
  padding: 6px;
  width: 100%;

  &:hover {
    background-color: ${COLORS.grayBorder};
    cursor: pointer;
  }
`;

export const EditorCellMixin = css`
  border: none;
  box-sizing: border-box;
  color: ${PANDA_COLORS.greyDark1};
  font-size: 13px;
  height: 34px;
  outline: none;
  padding: 7px;
  width: 100%;
`;

/** Inputs */
export const isInputDisabledMixin = css`
  border: 1px solid ${COLORS.grayLightDisabled};
  color: ${COLORS.grayTextDisabled};
`;

export const isInputNormalMixin = css`
  border: 1px solid ${COLORS.grayDisabled};
  color: ${COLORS.grayText};

  &:focus,
  &:active {
    border: 1px solid ${COLORS.blue};
  }
`;

export const isInputErrorMixin = css`
  border: 1px solid ${COLORS.red};

  &:focus,
  &:active {
    border: 1px solid ${COLORS.red};
  }
`;

export const isInputBtnNormalMixin = css`
  border: 1px solid ${COLORS.grayDisabled};
  color: ${COLORS.grayText};
  cursor: pointer;

  &:focus,
  &:active {
    border: 1px solid ${COLORS.blue};
  }
`;

export const FormViewTheme = {
  mainPadding: '32px',
  mainWidth: '640px',
  headerTopMarginLarge: '140px',
  headerTopMarginSmall: '80px',
};

/** Onboarding */
export const MainOnboardingBorderMixin = css`
  border: 4px solid ${COLORS.blue};
  outline: none;
`;

export const MobileWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding: 0 20px;

  @media ${Device.tabletLandscape} {
    display: none !important;
  }
`;

export const LargeScreenOnly = styled.div`
  display: none;

  @media ${Device.tabletLandscape} {
    display: block;
  }
`;

export const SmallScreenOnly = styled.div`
  @media ${Device.tabletLandscape} {
    display: none;
  }
`;
